/**
 * Vue i18n Configuration
 * Configura l'internazionalizzazione per l'applicazione
 */
import { createI18n } from 'vue-i18n'
import it from './locales/it.json'
import en from './locales/en.json'
import { getInitialLocale } from './utils/locale';

// Preferenza utente salvata oppure lingua del browser (it/en); default contenutistico 'it'.
const savedLanguage = getInitialLocale();

const i18n = createI18n({
  legacy: false, // Usa Composition API
  locale: savedLanguage, // Lingua dall'utente o default
  fallbackLocale: 'en', // Lingua di fallback
  messages: {
    it,
    en
  }
})

export default i18n
